/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

const SidebarSection = styled(({ children, ...props }) => (
  <Grid {...props} item xs={12} md={3} xl={2}>
    <div className="sidebar-section min-height">{children}</div>
  </Grid>
))`
  ${({ theme }) => `
    .sidebar-section {
      background-color: #f5f5f5;
      padding: ${theme.spacing(3)}px ${theme.spacing(2)}px;

      ${theme.breakpoints.up("md")} {
        padding: ${theme.spacing(6)}px ${theme.spacing(3)}px;
      }
    }
  `}
`;

export default SidebarSection;
